<template>
  <div>
    <ask
      @ok="startMembership"
      ref="noApproval"
      title="Start without Authorization"
      message="Are you sure you would like to start this membership plan without the patient's signed authorization?"
    ></ask>

    <b-modal v-b-modal.modal-center no-close-on-backdrop ref="sendingEmail">
      <div class="text-center">
        <svg
          width="90"
          height="90"
          viewBox="0 0 44 44"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#59A5D8"
        >
          <g fill="none" fill-rule="evenodd" stroke-width="2">
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="0s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="0s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="-0.9s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="-0.9s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
        <br />
        <br />

        <h2>Waiting on text confirmation</h2>
        We have sent an text to {{ copiedCell || phone }} with a link to agree
        to the payment plan.
        <br />
        <b-button variant="danger" class="mt-5 btn-block" @click="cancelEmail"
          >Cancel</b-button
        >
      </div>

      <template #modal-header>
        <div class="w-100"></div>
      </template>
      <template #modal-footer><div></div> </template>
    </b-modal>

    <b-modal
      ref="membershipReview"
      lazy
      size="xl"
      hide-footer
      aria-label=""
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
    >
      <template #modal-title="{ close }">
        <div>
          Membership for {{ customer.firstName }} {{ customer.lastName }}
        </div>
      </template>

      <b-row class="m-0">
        <b-col class="modal-hero">
          <b-card class="p-0 m-0 shadow-none">
            <b-row>
              <b-col
                class="pl-3 pr-0 panel-first"
                v-if="startAction == 'LATER'"
              >
                <div class="card-panel">
                  <div class="stat-box-title">Sending to</div>
                  <div class="stat-box-body">
                    <span v-if="form.emailToNotify" class="pr-2">
                      <i
                        class="title-icon fa-solid fa-circle-envelope pl-0"
                        v-b-tooltip.hover
                        :title="form.emailToNotify"
                      ></i>
                      Email
                    </span>
                    <span v-if="form.phoneToNotify">
                      <i
                        class="title-icon fa-solid fa-circle-phone"
                        v-b-tooltip.hover
                        :title="form.phoneToNotify"
                      ></i>
                      Mobile
                    </span>
                  </div>
                </div>
              </b-col>
              <b-col
                class="pl-0 pr-0 panel-divider"
                v-if="startAction == 'LATER'"
              >
                <div class="card-panel">
                  <div class="stat-box-title">Start Date</div>
                  <div class="stat-box-body">
                    {{ form.startDate | moment("MM/DD/YYYY") }}
                    <i
                      v-if="startAction == 'LATER'"
                      class="title-icon fa-solid fa-circle-info"
                      v-b-tooltip.hover
                      title="If the patient doesn't complete their membership by the start date, the start date will be moved to the completed date."
                    ></i>
                  </div>
                </div>
              </b-col>
              <b-col class="pl-3 pr-0 panel-first" v-if="startAction == 'NOW'">
                <div class="card-panel">
                  <div class="stat-box-title">Start Date</div>
                  <div class="stat-box-body">
                    {{ form.startDate | moment("MM/DD/YYYY") }}
                    <i
                      v-if="startAction == 'LATER'"
                      class="title-icon fa-solid fa-circle-info"
                      v-b-tooltip.hover
                      title="If the patient doesn't complete their membership by the start date, the start date will be moved to the completed date."
                    ></i>
                  </div>
                </div>
              </b-col>
              <b-col
                class="pl-0 pr-0 panel-divider"
                v-if="form.downPayment > 0"
              >
                <div class="card-panel">
                  <div class="stat-box-title">
                    Down Payment
                  </div>
                  <div class="stat-box-body">
                    {{ form.downPayment | currency }}
                    <i
                      class="title-icon fa-solid fa-circle-info"
                      v-b-tooltip.hover
                      title="Down payment will be collected on the start date, and will not be included in renewals."
                    ></i>
                  </div>
                </div>
              </b-col>
              <!--<b-col class="pl-0 pr-0 panel-divider">
                <div class="card-panel">
                  <div class="stat-box-title">Cycle</div>
                  <div class="stat-box-body">
                    {{ form.cycleOption | title }}
                  </div>
                </div>
              </b-col>-->
              <b-col class="pl-0 pr-0 panel-divider ">
                <div class="card-panel">
                  <div class="stat-box-title">
                    {{ form.cycleOption | title }} Payment
                  </div>
                  <div class="stat-box-body">
                    {{ form.payment | currency }}
                  </div>
                </div>
              </b-col>

              <b-col
                class="pl-0 pr-0 panel-divider"
                v-if="startAction == 'NOW'"
              >
                <div class="card-panel">
                  <div class="stat-box-title">
                    <span v-if="!isToday(form.startDate)">Processing </span>
                    {{
                      isToday(form.startDate)
                        ? "Processing Today"
                        : form.startDate | moment("MM/DD/YYYY")
                    }}
                  </div>
                  <div class="stat-box-body">
                    {{
                      (Number(form.downPayment) + Number(form.payment))
                        | currency
                    }}
                  </div>
                </div>
              </b-col>

              <b-col
                class="pl-0 pr-3 panel-divider"
                md="auto"
                v-if="form.patientCard"
              >
                <div class="card-panel text-right">
                  <div style="float: left;">
                    <div class="stat-box-title">Card Number</div>
                    <div class="stat-box-body">
                      {{ form.patientCard.description }}
                    </div>
                  </div>
                  <div style="float: left;" class="fixed ml-4">
                    <card-svg-large
                      height="40px"
                      :cardType="form.patientCard.cardType"
                    ></card-svg-large>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="m-0">
        <b-col class="body-modal">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="pl-0">Membership Plan</th>
                <th scope="col" class="text-right">
                  {{ form.cycleOption | title }} Amount
                </th>
                <th scope="col" class="text-right">Quantity</th>
                <th scope="col" class="text-right pr-0">
                  {{ form.cycleOption | title }} Payment
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="membership in memberships.filter((e) => e.qty > 0)"
                v-bind:key="membership.id"
              >
                <td class="pl-0">
                  <b class="mb-2">{{ membership.label }}</b>

                  <div
                    v-for="benefit in membership.membershipBenefits"
                    v-bind:key="benefit.id"
                    class="text-muted"
                  >
                    {{ benefit.label }}
                  </div>
                </td>
                <td class="text-right">
                  <div v-if="form.cycleOption == 'YEARLY'">
                    {{ (membership.yearlyAmount / 100) | currency }}
                  </div>
                  <div v-if="form.cycleOption == 'MONTHLY'">
                    {{ (membership.monthlyAmount / 100) | currency }}
                  </div>
                </td>
                <td class="text-right">
                  {{ membership.qty }}
                </td>
                <td class="text-right pr-0">
                  <div
                    v-if="form.cycleOption == 'MONTHLY' && membership.qty > 0"
                  >
                    {{
                      ((membership.monthlyAmount * membership.qty) / 100)
                        | currency
                    }}
                  </div>
                  <div
                    v-if="form.cycleOption == 'YEARLY' && membership.qty > 0"
                  >
                    {{
                      ((membership.yearlyAmount * membership.qty) / 100)
                        | currency
                    }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>

      <div v-if="startAction == 'NOW'">
        <b-row class="m-0" v-if="state == 'ready' && !approved && template">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <hr />

            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Membership Review & Authorization
            </h6>
            <h5 class="h3 mb-4">Electronic Signature</h5>

            <base-input-phone v-model="copiedCell">
              <template #appendButton>
                <b-button
                  class="btn btn-outline-primary shadow-none"
                  variant="primary"
                  :disabled="!copiedCell"
                  @click="emailAndApprove"
                >
                  <i class="fa-solid fa-signal-stream"></i>
                  &#160; Send
                </b-button>
              </template>
            </base-input-phone>
          </b-col>
        </b-row>

        <b-row class="m-0" v-if="state == 'waiting'">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <hr />

            <div>
              <div class="row">
                <div class="col-3" style="text-align:center">
                  <img
                    style="width:100px;margin-left:20px"
                    src="@/assets/img/signature.gif"
                  />
                  <br /><br />
                  <a href="#" @click.prevent="cancelSignature">Cancel</a>
                </div>
                <div class="col-9">
                  <h3>
                    Waiting for Patient Authorization...
                  </h3>
                  <p class="text-muted">
                    A text message has been sent to
                    {{ copiedCell | phone }}. You can start the membership plan
                    as soon as the patient completes their authorization.
                  </p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="m-0" v-if="state == 'approved'">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <hr />
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Membership Review & Authorization
            </h6>
            <h5 class="h3 text-success">
              <i
                v-b-tooltip.hover
                title="Signed"
                class="fa-solid fa-badge-check text-success"
              ></i>
              Authorization Completed
            </h5>

            <div
              class="mt-2 p-2"
              style="border: dotted 1px #ccc; display: inline-block;"
            >
              <img :src="approved.signature" height="125" />
            </div>
          </b-col>
        </b-row>

        <b-row class="m-0">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <b-button
              v-if="!approved && template"
              class="btn-block"
              variant="primary"
              type="button"
              @click="$refs.noApproval.ask()"
              >Start Membership without Authorization</b-button
            >

            <b-button
              v-if="(approved && template) || !template"
              class="btn-block"
              variant="primary"
              type="button"
              @click="startMembership"
              >Start Membership</b-button
            >
          </b-col>
        </b-row>
      </div>
      <div v-if="startAction == 'LATER'">
        <b-row class="m-0">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <b-button
              class="btn-block"
              variant="primary"
              type="button"
              @click="startMembership"
              >Send to Patient to Complete</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      ref="membershipModal"
      id="memberModal"
      body-class="p-0 m-0"
      hide-footer
      hide-header
    >
      <b-card
        :img-src="'img/membership/' + selectedMembership.imageId"
        img-alt="Image"
        img-top
        tag="article"
        style="max-width: 100%"
        class="mb-0"
      >
        <b-card-text>
          <h2>{{ selectedMembership.label }}</h2>
          <div class="text-muted">{{ selectedMembership.description }}</div>
          <hr class="mt-4 mb-2 p-0" />
          <h3>Benefits</h3>
          <ul
            class="modal-benefits text-muted"
            v-for="item in selectedMembership.membershipBenefits"
            v-bind:key="item.id"
          >
            <li>{{ item.label }}</li>
          </ul>
        </b-card-text>
        <b-button
          class="btn-block"
          variant="primary"
          @click="$refs.membershipModal.hide()"
          >Close</b-button
        >
      </b-card>
    </b-modal>

    <div>
      <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
        <b-form role="form" @submit.prevent="handleSubmit(onReview)">
          <div>
            <b-row class="pb-5">
              <b-col>
                <b-button-group size="sm">
                  <b-button
                    @click="startAction = 'LATER'"
                    :variant="
                      startAction == 'LATER' ? 'primary' : 'outline-primary'
                    "
                    ><i class="fa-solid fa-paper-plane"></i
                    >&#160;&#160;&#160;Patient Completes</b-button
                  >
                  <b-button
                    @click="startAction = 'NOW'"
                    :variant="
                      startAction == 'NOW' ? 'primary' : 'outline-primary'
                    "
                    ><i class="fa-solid fa-credit-card"></i
                    >&#160;&#160;&#160;Practice Completes</b-button
                  >
                </b-button-group>
              </b-col>
            </b-row>

            <b-row class="m-0">
              <b-col class="p-0 card shadow-none border">
                <b-row class="m-0 p-0 h-100 border-bottom" align-v="end">
                  <b-col class="p-3 form-control-label">
                    Membership Plan
                  </b-col>
                  <b-col class="p-3 form-control-label text-right">
                    {{ form.cycleOption | title }} Amount
                  </b-col>
                  <b-col class="p-3 form-control-label text-right">
                    Quantity
                  </b-col>
                  <b-col class="p-3 form-control-label text-right">
                    {{ form.cycleOption | title }} Payment
                  </b-col>
                </b-row>
                <div
                  v-for="membership in memberships"
                  v-bind:key="membership.id"
                >
                  <b-row class="m-0 p-0 border-bottom" align-v="center">
                    <b-col class="p-3">
                      <a href="#" @click.prevent="showMembership(membership)">{{
                        membership.label
                      }}</a>
                    </b-col>
                    <b-col
                      class="p-3 text-right"
                      v-if="form.cycleOption == 'YEARLY'"
                    >
                      <a
                        href="#"
                        v-show="!membership.showYearly"
                        @click.prevent="editYearly(membership)"
                        >{{ (membership.yearlyAmount / 100) | currency }}
                      </a>

                      <div class="float-right">
                        <b-input-group
                          class="mem-amount"
                          v-if="membership.showYearly"
                        >
                          <base-input-currency
                            name="payment"
                            ref="payment"
                            mode="lazy"
                            inputClasses="form-control-sm amount-edit"
                            rules="required|money|greaterThanZero"
                            v-model="membership.yearlyConverted"
                          ></base-input-currency>
                          <b-input-group-append>
                            <b-button
                              size="sm"
                              text="Button"
                              v-if="membership.showYearly"
                              @click="saveYearly(membership)"
                              variant="secondary"
                              class="shadow-none pr-3 pl-3"
                              ><i class="fa-solid fa-floppy-disk"></i
                            ></b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </b-col>

                    <b-col
                      class="p-3 text-right"
                      v-if="form.cycleOption == 'MONTHLY'"
                    >
                      <a
                        href="#"
                        v-show="!membership.showMonthly"
                        @click.prevent="editMonthly(membership)"
                        >{{ (membership.monthlyAmount / 100) | currency }}</a
                      >

                      <div class="float-right">
                        <b-input-group
                          class="mem-amount"
                          v-if="membership.showMonthly"
                        >
                          <base-input-currency
                            name="payment"
                            ref="payment"
                            mode="lazy"
                            rules="required|money|greaterThanZero"
                            inputClasses="form-control-sm amount-edit"
                            v-model="membership.monthlyConverted"
                          ></base-input-currency>
                          <b-input-group-append>
                            <b-button
                              size="sm"
                              text="Button"
                              v-if="membership.showMonthly"
                              @click="saveMonthly(membership)"
                              variant="secondary"
                              class="shadow-none pr-3 pl-3"
                              ><i class="fa-solid fa-floppy-disk"></i
                            ></b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </b-col>

                    <b-col class="p-3 text-right">
                      <b-select
                        :options="qty"
                        style="width: 140px"
                        v-model="membership.qty"
                        @change="qtyChange"
                        size="sm"
                      ></b-select>
                    </b-col>

                    <b-col class="p-3 text-right">
                      <div
                        v-if="
                          form.cycleOption == 'MONTHLY' && membership.qty > 0
                        "
                      >
                        {{
                          ((membership.monthlyAmount * membership.qty) / 100)
                            | currency
                        }}
                      </div>
                      <div
                        v-if="
                          form.cycleOption == 'YEARLY' && membership.qty > 0
                        "
                      >
                        {{
                          ((membership.yearlyAmount * membership.qty) / 100)
                            | currency
                        }}
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <b-row class="m-0">
                  <b-col class="p-0 p-3" style="text-align: right">
                    <div class="form-control-label">
                      Total {{ form.cycleOption | title }} Payment
                    </div>
                    <h2 class="mb-0">
                      {{ Number(form.payment) | currency }}
                    </h2>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>

          <div>
            <b-row>
              <b-col v-if="startAction == 'NOW'">
                <div>
                  <customer-saved-cards
                    v-on:onCustomerCardSelect="onCustomerCardSelect"
                    name="customerCards"
                    onCustomerCardSelect="onCustomerSelect"
                    :customer="customer"
                  ></customer-saved-cards>
                </div>
              </b-col>
              <b-col :cols="startAction != 'NOW' ? 6 : 3">
                <label for="example-datepicker" class="form-control-label"
                  >Start Date
                  <i
                    v-if="startAction == 'LATER'"
                    class="title-icon fa-solid fa-circle-info"
                    v-b-tooltip.hover
                    title="If the patient doesn't complete their membership by the start date, the start date will be moved to when the patient completes their enrollment."
                  ></i
                ></label>

                <b-form-datepicker
                  v-model="form.startDate"
                  value-as-date
                  class="col-sm-12"
                  :min="todayDate"
                ></b-form-datepicker>
              </b-col>
              <b-col cols="3">
                <label for="example-datepicker" class="form-control-label"
                  >Down Payment
                  <i
                    class="title-icon fa-solid fa-circle-info"
                    v-b-tooltip.hover
                    title="Down payment will be collected on the start date, and will not be included in renewals."
                  ></i
                ></label>
                <base-input-currency v-model="form.downPayment" />
              </b-col>
              <b-col cols="3">
                <m-select
                  :options="cycleOptions"
                  v-model="form.cycleOption"
                  @change="setTotal"
                  label="Cycle"
                ></m-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="startAction != 'NOW'" cols="12">
                <base-textarea
                  v-model="form.note"
                  label="Note"
                  rows="5"
                  placeholder="This note will be displayed to the patient when reviewing and completing their membership."
                >
                </base-textarea>
              </b-col>
            </b-row>
            <b-row v-if="startAction != 'NOW'">
              <b-col>
                <b-form-checkbox v-model="sendPhone" switch size="sm">
                  Text Message</b-form-checkbox
                >

                <div style="margin-top:7px">
                  <base-input-phone
                    v-model="form.phoneToNotify"
                    :disabled="!sendPhone"
                  />
                </div>
              </b-col>
              <b-col>
                <b-form-checkbox v-model="sendEmail" switch size="sm">
                  E-Mail</b-form-checkbox
                >
                <div style="margin-top:7px">
                  <base-input
                    prependIcon="ni ni-email-83"
                    v-model="form.emailToNotify"
                    :disabled="!sendEmail"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="pt-2">
              <b-col>
                <b-button class="btn-block" variant="primary" type="submit"
                  >Review Membership</b-button
                >
              </b-col>
            </b-row>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import CustomerSavedCards from "@/views/Components/CustomerSavedCards";
import * as signalR from "@microsoft/signalr";
import { Printd } from "printd";
import swal from "sweetalert2";

export default {
  name: "on-going",
  props: { customer: null },

  components: {
    CustomerSavedCards,
  },
  watch: {
    sendEmail: {
      handler: function(val) {
        if (!val) {
          this.form.emailToNotify = null;
        } else {
          this.form.emailToNotify = this.customer.email;
        }
      },
      immediate: true,
    },
    sendPhone: {
      handler: function(val) {
        if (!val) {
          this.form.phoneToNotify = null;
        } else {
          this.form.phoneToNotify = this.customer.cell;
        }
      },
      immediate: true,
    },
  },
  data: function() {
    return {
      startAction: "LATER",
      notifyEmail: null,
      sendEmail: false,
      sendPhone: false,

      selectedMembership: {},
      qtySelected: "",
      qty: [
        { value: "", text: "Select Qty.." },

        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
      ],
      state: "ready",
      cycleOptions: [
        { value: "MONTHLY", text: "Monthly" },
        { value: "YEARLY", text: "Yearly" },
      ],
      ogMemberships: [],
      memberships: [],
      approved: null,
      todayDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
      template: null,
      copiedCell: null,
      form: {
        cycleOption: "YEARLY",
        patientCard: null,
        payment: null,
        phoneToNotify: null,
        emailToNotify: null,
        note: null,
        downPayment: null,
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        ),
      },
    };
  },
  created() {
    var self = this;

    if (this.customer.email) {
      this.sendEmail = true;
      this.emailToNotify = this.customer.email;
    } else this.sendEmail = false;

    if (this.customer.cell) {
      this.sendPhone = true;
      this.form.phoneToNotify = this.customer.cell;
    } else {
      this.sendPhone = false;
    }

    self.bind();
  },
  beforeDestroy() {
    this.disconnectHub();
  },
  methods: {
    cancelSignature() {
      this.disconnectHub();
      this.state = "ready";
    },
    cancelEmail() {
      try {
        this.disconnectHub();
      } catch {}
      this.$refs.sendingEmail.hide();
    },
    disconnectHub() {
      this.connection.stop();
    },
    buildMembershipPreviewRequest() {
      return {
        ...this.form,
        cell: this.copiedCell,
        memberships: this.memberships.filter((e) => e.qty > 0),
        customerId: this.customer.id,
      };
    },
    async emailAndApprove() {
      var self = this;

      self.form.customerId = self.customer.id;
      self.form.customerSavedCardId = self.form.patientCard.id;

      var r = await self.$client.post("/api/membership/sendTextConfirmation", {
        membershipPreviewRequest: this.buildMembershipPreviewRequest(),
      });

      if (r.data.isSuccess) {
        this.state = "waiting";
        console.log(r.data.value.url);

        this.connection = new signalR.HubConnectionBuilder()
          .withUrl(
            r.data.value.patientPortalUri +
              "/signalr?coalesceId=" +
              r.data.value.coalesceId
          )
          .configureLogging(signalR.LogLevel.Information)
          .withAutomaticReconnect()
          .build();

        await this.connection.start();

        this.connection.on("approved", (message) => {
          self.approved = {
            method: this.copiedCell,
            cell: this.copiedCell,
            ipAddress: message.ipAddress,
            signature: message.signature,
            date: new Date(),
          };
          this.state = "approved";
          swal
            .fire({
              title: "Authorization Completed",
              text:
                "The membership plan has been reviewed and authorized by the patient. You can now start the membership.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            })
            .then((e) => {});
          this.disconnectHub();
        });
      }
    },
    async print() {
      var self = this;
      self.state = "printandsign";

      await this.$nextTick();

      const cssText = `
        h1 {
          color: black;
          font-family: sans-serif;
        }

        html {
          font-size:10px;
        }

        .vertical-center {
        min-height: 100%;  /* Fallback for browsers do NOT support vh unit */
        min-height: 100vh; /* These two lines are counted as one :-)       */

        display: flex;
        align-items: center;
      }
      `;

      const d = new Printd();

      d.print(
        document.getElementById("printDiv"),
        [
          cssText,
          "https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css",
        ],
        null,
        function({ launchPrint }) {
          launchPrint();
          self.state = "ready";
          self.approved = {
            method: "Print & Sign",
            name: localStorage.getItem("name"),
          };
        }
      );
    },
    showMembership(membership) {
      this.selectedMembership = membership;
      this.$refs.membershipModal.show();
    },
    saveMonthly(membership) {
      membership.monthlyAmount = (membership.monthlyConverted * 100).toFixed(0);
      membership.showMonthly = false;
      this.setTotal();
    },
    saveYearly(membership) {
      membership.yearlyAmount = (membership.yearlyConverted * 100).toFixed(0);
      membership.showYearly = false;
      this.setTotal();
    },
    editMonthly(membership) {
      membership.showMonthly = true;
    },
    editYearly(membership) {
      membership.showYearly = true;
    },
    getSavings(listPrice, actualPrice) {
      var per = ((listPrice - actualPrice) / listPrice) * 100;

      if (per >= 0) return per.toFixed(0) + "% Savings";
      else return per.toFixed(0) + "% Not Being Saved";
    },
    buildPost() {
      return {
        customerSavedCardId: this.form.patientCard
          ? this.form.patientCard.id
          : null, // if we are sending them this will be null
        payment: this.form.payment,
        startDate: this.form.startDate,
        cycle: this.form.cycleOption,
        memberships: this.memberships.filter((e) => e.qty > 0),
        customerId: this.customer.id,
        approved: this.approved,
        note: this.form.note,
        downPayment: this.form.downPayment,
        notifyEmail: this.form.emailToNotify,
        notifyMobile: this.form.phoneToNotify,
        awaitingPatient: this.startAction == "NOW" ? false : true,
      };
    },
    async startMembership() {
      var self = this;

      var r = await self.$client.post("/api/membership/startMembership", {
        startMembershipModel: this.buildPost(),
      });

      if (r.data.isSuccess) {
        if (r.data.value.notifiedPatient) {
          self.$emitter.emit("success-confirm", {
            title: "Membership Sent",
            navigate: "/#/dashboard",
            message:
              "The membership has been sent to the patient to be completed.",
          });
        } else if (!r.data.value.processedCard) {
          self.$emitter.emit("success-confirm", {
            title: "Membership Created",
            navigate: "/#/dashboard",
            message:
              "The billing for the selected memberships has been scheduled and will start on " +
              self.$moment(self.form.startDate).format("MM/DD/YYYY"),
          });
        } else {
          if (r.data.value.isApproved) {
            self.$emitter.emit("success-confirm", {
              title: "Membership Started",
              navigate: "/#/dashboard",
              message:
                "The billing for the selected memberships has started, and the first payment was processed successfully.",
            });
          } else if (!r.data.value.isApproved) {
            self.$emitter.emit("noSuccess-confirm", {
              title: "Membership Error",
              message:
                "The membership was not created. The patients card declined because " +
                r.data.value.reason +
                ".  Please enter a new card to process.",
            });
          }
        }
      }
    },
    qtyChange() {
      this.setTotal();
    },
    setTotal() {
      var self = this;

      let total = 0;

      self.memberships.forEach(function(membership) {
        if (membership.qty > 0) {
          let t = 0;
          if (self.form.cycleOption == "MONTHLY") {
            t = (membership.monthlyAmount * membership.qty) / 100;
            membership.amountConverted = membership.monthlyAmount / 100;
          } else {
            t = (membership.yearlyAmount * membership.qty) / 100;
            membership.amountConverted = membership.yearlyAmount / 100;
          }
          total += t;
          membership.totalConverted = t;
        }
      });

      console.log(self.memberships);

      self.form.payment = total.toFixed(2);
    },

    async bind() {
      var self = this;
      var r = await self.$client.get(
        "/api/membership/getMemberships?isActive=true"
      );

      r.data.value.forEach((e) => {
        e.selected = false;
        e.showMonthly = false;
        e.showYearly = false;
        e.qty = "";
        e.monthlyConverted = e.monthlyAmount / 100;
        e.yearlyConverted = e.yearlyAmount / 100;
      });

      self.memberships = r.data.value;
    },

    onCustomerCardSelect(patientCard) {
      this.form.patientCard = patientCard;
    },
    async onReview() {
      if (this.startAction == "LATER" && !this.sendEmail && !this.sendPhone) {
        this.$emitter.emit(
          "error",
          "If your going to notify the patient, you must have at least one notification method seleted"
        );
        return;
      }

      this.copiedCell = this.customer.cell;

      let hasOneSelected = this.memberships.find((e) => e.qty > 0);

      if (!hasOneSelected) {
        this.$emitter.emit("error", "You must select at least one membership");
        return;
      }

      let r = await this.$client.post("/api/membership/getMembershipTemplate", {
        firstName: this.customer.firstName,
        lastName: this.customer.lastName,
        membershipAmount: this.form.payment,
        cycle: this.form.cycleOption,
        startDate: this.form.startDate,
      });

      this.approved = null;
      this.state = "ready";

      this.template = r.data.value.membershipTemplateLegal;

      this.$refs.membershipReview.show();
    },

    isToday() {
      var self = this;
      var s1 = new Date(self.form.startDate).setHours(0, 0, 0, 0);
      var s2 = new Date().setHours(0, 0, 0, 0);
      return s1 === s2;
    },
  },
};
</script>

<style>
.icon-status-approved {
  font-size: 0.9em;
  position: relative;
  top: 1px;
}

#planRow {
  cursor: pointer;
}

.borderless td,
.borderless th {
  border: none;
}

#memberModal .modal-header {
  display: none;
}

.divider {
  border-bottom: solid 1px #dee2e6;
  display: block;
  clear: both;
  overflow: hidden;
}

.table thead th,
.el-table thead th {
  border-top: 0;
}

.amount-edit.form-control {
  height: 36px !important;
  display: inline-block;
  font-size: 0.9em;
  max-width: 100px !important;
  border-radius: 0;
}

.mem-amount {
  height: 36px !important;
}

.mem-amount .input-group-prepend .input-group-text {
  height: 36px !important;
  font-size: 0.9em !important;
}

ul.modal-benefits,
ul.modal-benefits li {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
</style>
